import { render, staticRenderFns } from "./presentationCpts.vue?vue&type=template&id=f5ba8d60&scoped=true&"
import script from "./presentationCpts.vue?vue&type=script&lang=js&"
export * from "./presentationCpts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba8d60",
  null
  
)

export default component.exports